import styled from 'styled-components';

const HeadingEditLayout = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    column-gap: ${({ theme }) => theme.Spacing.spacing3x};
`;

export default HeadingEditLayout;
